const PROJECTS = [
    {
        id: "chemical-reactor",
        name: "Chemical Reactor",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: "Jacketed stirred reactor with vacuum capability, featuring a motor-driven agitator, sealed vessel, and viewing ports for controlled mixing and temperature-regulated batch processing",
        formats: ["stl"],
        url: "models/chemical-reactor.stl",
        format: "stl",
        rotation: [-2.7, 2.3, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "waterjet-table",
        name: "Waterjet Table",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: "Waterjet cutting table modeled from 2d drawings into a complete 3d cad assembly, including structural frame, cutting bed, and component layout",
        formats: ["stl"],
        url: "models/waterjet-table.stl",
        format: "stl",
        rotation: [-2.6, 2.3, -3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 155,
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "Pole Straightening Machine",
        name: "Pole Machine",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: "Hydraulically actuated machine for correcting bent structural poles, with adjustable positioning for controlled force application along the workpiece axis",
        formats: ["stl"],
        url: "models/pole_straightening_final_assemb.stl",
        format: "stl",
        rotation: [3.1, -2.6, -3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 125,
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "Factory-layout-compressed",
        name: "Factory Layout",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: "Complete factory layout for an hdpe plant from sheet coil handling through forming and processing to finished water tank production, optimized for workflow and material flow",
        formats: ["stl"],
        url: "models/Factory-layout-compressed.stl",
        format: "stl",
        rotation: [-2.7, -0.7, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 130,
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "motor-assembly",
        name: "Spherical Induction Motor",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: "2-DOF spherical induction motor with stator mounts, rotor housing, coil slots, and modular aluminum framing, fabricated using laser cut silicon steel laminations and 3d printed alignment jigs",
        formats: ["stl"],
        url: "models/motor-assembly.stl",
        format: "stl",
        rotation: [-2.7, -0.7, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 130,
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "wheel_assembly",
        name: "Wheel - Reverse Engineered",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: "Reverse engineered truck wheel from physical measurements and 3D scan data, reconstructed into a precise cad model for documentation and manufacturing reference",
        formats: ["stl"],
        url: "models/wheel_assembly.stl",
        format: "stl",
        rotation: [-2.7, -0.7, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 130,
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "powder_coating",
        name: "Powder Coating Line",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: "Mobile powder coating assembly including gantry system, curing furnace, and electroplating booth, designed for flexible deployment and end-to-end surface finishing workflow",
        formats: ["stl"],
        url: "models/powder_coating.stl",
        format: "stl",
        rotation: [-2.7, -0.7, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 130,
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "roll",
        name: "Conveyor Roller",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: "Crown conveyor roller with a contoured surface profile to improve belt tracking and reduce lateral slippage in material handling systems",
        formats: ["stl"],
        url: "models/roll.stl",
        format: "stl",
        rotation: [-2.5, 2.3, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 175,

        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "slanted_pipe_jaws",
        name: "Pipe Jaws",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: " Custom pipe jaw tooling for roll forming operations, designed for secure workpiece clamping and consistent forming force distribution",
        formats: ["stl"],
        url: "models/slanted_pipe_jaws.stl",
        format: "stl",
        rotation: [-2.5, 2.3, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 80,

        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "shed-layout",
        name: "Shed Layout",
        category: "Industry",
        year: "2025",
        software: "Creo",
        description: "Machine layout for an hdpe plant defining optimal placement of equipment from sheet coil handling to forming and assembly areas for efficient workflow and space utilization",
        formats: ["stl"],
        url: "models/shed-layout.stl",
        format: "stl",
        rotation: [-2.7, 0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 120,
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "potato-cutting",
        name: "Potato Cutter",
        category: "Commercial",
        year: "2025",
        software: "Creo",
        description: "Crinkle cut potato cutting mechanism for consistent wavy cuts and efficient manual or automated operation",
        formats: ["stl"],
        url: "models/potato-cutting.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "Medal-UIUC-DemLab",
        name: "Medal UIUC DemLab",
        category: "Commercial",
        year: "2025",
        software: "Creo",
        description: "3d printable scavenger hunt medal for UIUC DEMLab featuring the lab mascot, optimized for additive manufacturing and event recognition",
        formats: ["stl"],
        url: "models/Medal-UIUC-DemLab.stl",
        format: "stl",
        rotation: [-0.362, 0, 0],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "Desk-Piece-Victory-Pipe",
        name: "Desk Piece Victory Pipe",
        category: "Commercial",
        year: "2025",
        software: "Creo",
        description: "3d printed desk organizer for victory pipe combining pen, card, and sticky note storage, with integrated pipe-inspired lamp post elements as part of the structure",
        formats: ["stl"],
        url: "models/Desk-Piece-Victory-Pipe.stl",
        format: "stl",
        rotation: [0.208, 0.508, 0],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],

        // ambient: 0.55, key: 1.50 @ [-6.0,8.0,6.0]
        // fill: 0.40 @ [6.0,2.0,4.0]
        // rim: 0.25 @ [0.0,-4.0,-8.0]
        // metalness: 0.75, roughness: 0.60
    },
    {
        id: "fireplace",
        name: "Fireplace",
        category: "Commercial",
        year: "2025",
        software: "Creo",
        description: "Sheet metal grill and fireplace combo for camping, laser-cut and foldable design optimized for portability, durability, and efficient heat distribution",
        formats: ["stl"],
        url: "models/fireplace.stl",
        format: "stl",
        rotation: [-0.27, 0.548, 0],
        rotationAxis: "y",
        initialView: [0.0, 0.15, 10.0],
        initialZoom: 91,
        // ambient: 0.55, key: 1.10 @ [-6.0,8.0,6.0]
        // fill: 0.35 @ [6.0,2.0,4.0]
        // rim: 0.20 @ [0.0,-4.0,-8.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "heart-sandwich-crimper-jls",
        name: "Sandwich Cutter",
        category: "Commercial",
        year: "2025",
        software: "Creo",
        description: "Heart shaped sandwich cutter and crimper for clean edge cutting and simultaneous sealing in a single press operation",
        formats: ["stl"],
        url: "models/heart-sandwich-crimper-jls.stl",
        format: "stl",
        rotation: [-0.27, 0.548, 0],
        rotationAxis: "y",
        initialView: [0.0, 0.15, 10.0],
        initialZoom: 91,
        // ambient: 0.55, key: 1.10 @ [-6.0,8.0,6.0]
        // fill: 0.35 @ [6.0,2.0,4.0]
        // rim: 0.20 @ [0.0,-4.0,-8.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "blimp",
        name: "Blimp Model",
        category: "Commercial",
        year: "2025",
        software: "Creo",
        description: "Artistic cad model of a blimp recreated from a music video reference",
        formats: ["stl"],
        url: "models/blimp.stl",
        format: "stl",
        rotation: [-0.27, 0.548, 0],
        rotationAxis: "y",
        initialView: [0.0, 0.15, 10.0],
        initialZoom: 91,
        // ambient: 0.55, key: 1.10 @ [-6.0,8.0,6.0]
        // fill: 0.35 @ [6.0,2.0,4.0]
        // rim: 0.20 @ [0.0,-4.0,-8.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "Water-Heater",
        name: "Water Heater",
        category: "Commercial",
        year: "2025",
        software: "Creo",
        description: "Electric water heater with custom insulation, WiFi connectivity, and app-based remote monitoring and control for temperature regulation and system status tracking",
        formats: ["stl"],
        url: "models/Water-Heater.stl",
        format: "stl",
        rotation: [-2.9, -2, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        initialZoom: 87,
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "tube",
        name: "Lamp Post",
        category: "Commercial",
        year: "2025",
        software: "Creo",
        description: "Complete lamp post assembly with integrated lighting system, including structural design, fixture placement, and electrical integration",
        formats: ["stl"],
        url: "models/tube.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "spur",
        name: "Spur Gear",
        group: "Parametric Gears",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Parametric spur gear model with scalable geometry, enabling easy adjustment of tooth profile, module, and gear ratio for different design requirements",
        formats: ["stl"],
        url: "models/spur.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "rack",
        name: "Gear Rack",
        group: "Parametric Gears",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Parametric rack geometry, enabling scalable tooth profiles and easy modification for different pitch and sizing requirements",
        formats: ["stl"],
        url: "models/rack.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "bevel",
        name: "Bevel Gear",
        group: "Parametric Gears",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Parametric bevel gear model with scalable geometry, allowing easy adjustment of tooth profile, pitch, and shaft angle for different design requirements",
        formats: ["stl"],
        url: "models/bevel.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "planetary_gear",
        name: "Planetary Gear Set",
        group: "Parametric Gears",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Planetary gear assembly with scalable geometry for adjustable gear ratio, tooth profile, and carrier configuration across different design requirements",
        formats: ["stl"],
        url: "models/planetary_gear.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "Pizza-Online-Anamorphic",
        name: "Pizza-Online",
        group: "Anamorphic Text",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Anamorphic Text Left - Right",
        formats: ["stl"],
        url: "models/Pizza-Online-Anamorphic.stl",
        format: "stl",
        rotation: [-3.1, -1.42, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "Tayyab-Kausar",
        name: "Tayyab-Kausar",
        group: "Anamorphic Text",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Anamorphic Text Top - Front",
        formats: ["stl"],
        url: "models/tayyab-kausar.stl",
        format: "stl",
        rotation: [-3.1, -1.42, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "Roy_Bilal",
        name: "Roy-Bilal",
        group: "Anamorphic Text",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Anamorphic Text Left - Right",
        formats: ["stl"],
        url: "models/roy_bilal.stl",
        format: "stl",
        rotation: [-3.1, -1.42, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2000-phase-1",
        name: "2000 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2000-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2000-phase-2",
        name: "2000 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2000-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2001-phase-1-try2",
        name: "2001 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2001-phase-1-try2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2001-phase-2",
        name: "2001 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2001-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2002-phase1-try-2",
        name: "2002 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2002-phase1-try-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2002-phase2-configb",
        name: "2002 Phase 2 Config B",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2002-phase2-configb.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2002-phase2-configc",
        name: "2002 Phase 2 Config C",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2002-phase2-configc.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2002-phase2-configd",
        name: "2002 Phase 2 Config d",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2002-phase2-configd.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2003-phase-1",
        name: "2003 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2003-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2003-phase-2",
        name: "2003 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2003-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2004-phase-1-try_2",
        name: "2004 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2004-phase-1-try_2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2004-phase-2",
        name: "2004 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2004-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2005-phase-1-try-1",
        name: "2005 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2005-phase-1-try-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2005-phase-2",
        name: "2005 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2005-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2006-phase-1-try1",
        name: "2006 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2006-phase-1-try1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2006-phase-2-try-1",
        name: "2006 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2006-phase-2-try-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2007-phase-1",
        name: "2007 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2007-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2007-phase-2",
        name: "2007 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2007-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2008-phase-1",
        name: "2008 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2008-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2008-phase-2",
        name: "2008 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2008-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2009-phase-1",
        name: "2009 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2009-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2009-phase-2",
        name: "2009 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2009-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "2010-phase-1",
        name: "2010 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2010-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2010-phase-2",
        name: "2010 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2010-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2011-phase-1",
        name: "2011 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2011-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2011-phase-2",
        name: "2011 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2011-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2012-phase-1",
        name: "2012 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2012-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2012-phase-2",
        name: "2012 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2012-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2013-phase-1",
        name: "2013 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2013-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2013-phase-2",
        name: "2013 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2013-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2014-phase-1",
        name: "2014 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2014-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2014-phase-2-try-1",
        name: "2014 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2014-phase-2-try-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2015-phase-1",
        name: "2015 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2015-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2015-phase-2",
        name: "2015 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2015-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2016-phase-1-try-1",
        name: "2016 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2016-phase-1-try-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2016-phase-2-try-1",
        name: "2016 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2016-phase-2-try-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2017-phase-1",
        name: "2017 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2017-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2017-phase-2",
        name: "2017 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2017-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2018-phase-1",
        name: "2018 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2018-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2018-phase-2",
        name: "2018 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2018-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2019-phase-1",
        name: "2019 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2019-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2019-phase-2",
        name: "2019 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2019-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2020-phase-1",
        name: "2020 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2020-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2020-phase-2",
        name: "2020 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2020-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2021-phase-1",
        name: "2021 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2021-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2022-phase-1-try-1",
        name: "2022 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2022-phase-1-try-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2023-phase-1",
        name: "2023 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2023-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2023-phase-2",
        name: "2023 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2023-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2024-phase-1",
        name: "2024 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2024-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2024-phase-2",
        name: "2024 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2024-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2025-phase-1",
        name: "2025 Phase 1",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2025-phase-1.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "2025-phase-2",
        name: "2025 Phase 2",
        group: "Model Mania",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "SolidWorks Model Mania practice models focused on fast, feature-based parametric design, emphasizing clean modeling practices and ease of modification for future design changes",
        formats: ["stl"],
        url: "models/ModelMania/2025-phase-2.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "clip-follower-pipe",
        name: "Air Aperture Mechanism",
        group: "Misc",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Cam-operated iris mechanism for a foundry opening that dynamically adjusts to varying pipe diameters, minimizing heat loss while allowing continuous material passage",
        formats: ["stl"],
        url: "models/clip-follower-pipe.stl",
        format: "stl",
        rotation: [-1.75, 0, -2.5],
        rotationAxis: "z",
        initialView: [0.0, 0.0, 10.0],
        // ambient: 0.70, key: 0.80 @ [12.5,3.5,8.0]
        // fill: 0.95 @ [-10.5,20.0,8.0]
        // rim: 1.00 @ [1.0,14.5,-9.0]
        // metalness: 0.70, roughness: 0.55
    },
    {
        id: "bottle_opener",
        name: "Bottle Opener",
        group: "Misc",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "University project bottle opener utilizing a iris mechanism for smooth, tool-free cap removal through radial blade actuation",
        formats: ["stl"],
        url: "models/bottle_opener.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "roof-solar-layout",
        name: "Home Solar Panel Layout",
        group: "Misc",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Home solar panel layout planning system sizing, panel placement, and orientation for efficient energy generation and integration with residential infrastructure",
        formats: ["stl"],
        url: "models/roof-solar-layout.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "tile-holder",
        name: "Tile Holder",
        group: "Misc",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Decorative tile holder formed from sheet metal, designed for secure mounting and clean aesthetic integration",
        formats: ["stl"],
        url: "models/tile-holder.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    {
        id: "Plastic Latch",
        name: "Plastic Latch",
        group: "Misc",
        category: "Hobby",
        year: "2025",
        software: "Creo",
        description: "Plastic latch modeled to study and validate snap-fit bending behavior and deflection characteristics under load",
        formats: ["stl"],
        url: "models/latch.stl",
        format: "stl",
        rotation: [-2.5, -0.6, 3.14],
        rotationAxis: "y",
        initialView: [0.0, 0.0, 10.0],
    },
    // ── Copy and paste a block like this for each new model ──────────────────
    // {
    //     id: "my-model",               ← unique, no spaces, use hyphens
    //     name: "Display Name",         ← shows in tab and info panel
    //     category: "Hobby",       ← Hobby, Electrical, Structural, etc.
    //     year: "2025",
    //     software: "Fusion 360",       ← Fusion 360, Inventor, Creo, SolidWorks
    //     description: "What this model is and what it does.",
    //     formats: ["stl"],
    //     url: "/models/my-model.stl",  ← must match filename in public/models/
    //     format: "stl",
    //
    //     rotation: [-Math.PI / 2, 0, 0],
    //     // Common rotation fixes:
    //     // [-Math.PI / 2, 0, 0]   front face forward (default, works for most Fusion exports)
    //     // [Math.PI / 2, 0, 0]    flip the other way
    //     // [Math.PI, 0, 0]        upside down fix
    //     // [0, 0, 0]              no correction
    //     // [-Math.PI / 2, 0, Math.PI / 2]   front face + 90° twist
    //
    //     rotationAxis: "z",
    //     // "y" — turntable spin (shows all sides, good for symmetric parts)
    //     // "z" — rolls sideways
    //     // "x" — tips forward/backward
    //
    //     initialView: [0, 0, 10],
    //     // [0, 0, 10]    straight front
    //     // [0, 5, 10]    slightly above front
    //     // [7, 4, 7]     isometric angle
    //     // [10, 0, 0]    from the right
    //     // [-10, 0, 0]   from the left
    // },
];

export default PROJECTS;